import { createSlice } from '@reduxjs/toolkit';
import { loadAdminAiUsage } from './thunks/loadAdminAiUsage.thunk';

/**
 * One report per month, kept so switching back to an already-viewed month is
 * instant. A refresh replaces the month's report; an error is per month too,
 * so a failed month does not hide the ones that loaded.
 */
const adminAiSlice = createSlice({
  name: 'adminAi',
  initialState: {
    reportsByMonth: {},
    loadingMonth: null,
    errorByMonth: {},
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(loadAdminAiUsage.pending, (state, action) => {
        state.loadingMonth = action.meta.arg;
        delete state.errorByMonth[action.meta.arg];
      })
      .addCase(loadAdminAiUsage.fulfilled, (state, action) => {
        state.reportsByMonth[action.meta.arg] = action.payload;
        if (state.loadingMonth === action.meta.arg) {
          state.loadingMonth = null;
        }
      })
      .addCase(loadAdminAiUsage.rejected, (state, action) => {
        state.errorByMonth[action.meta.arg] =
          action.payload || (action.error && action.error.message) || 'error';
        if (state.loadingMonth === action.meta.arg) {
          state.loadingMonth = null;
        }
      });
  },
});

export default adminAiSlice.reducer;
